import React from "react";
import CustomTable from "../helpers/customtable";
import formatPrice from "../helpers/formatPrice";
import "../../css/DashboardWorksTable.css";

const statusColors = {
  pending: { color: "#856404", background: "#fff3cd" },
  measured: { color: "#1d4ed8", background: "#dbeafe" },
  completed: { color: "#0f5132", background: "#d1e7dd" },
  cancelled: { color: "#842029", background: "#f8d7da" },
  active: { color: "#055160", background: "#cff4fc" }
};

export default function DashboardWorksTable({
  works,
  isCompany = false,
  isAdmin = false,
  users = [],
  t,
  formatDate,
  translateStatus,
  onRowClick
}) {
  const column = (key, label, width, align = "left") => ({
    key,
    header: t(label),
    shortHeader: t(`worksHeaderShort_${label}`),
    width,
    align,
    formatValue: ["clientPaid", "clientPrice", "label"].includes(key)
      ? formatPrice
      : undefined,
    default: t("none")
  });
  const dateColumn = (key, label) => ({
    ...column(key, label, "10%"),
    sortValue: (row) => row.dateValues[key]
  });
  const rows = works.map((work) => {
    const user = (users || []).find(
      (entry) => String(entry.userId) === String(work.user?.userId)
    );
    return {
      ...work,
      clientName: work.client?.name,
      carpenterName:
        user?.name || user?.username || work.user?.name || work.user?.username,
      partyName: isCompany
        ? user?.name || user?.username || work.user?.name || work.user?.username
        : work.client?.name,
      clientPaid: work.clientPaid || 0,
      clientPrice: work.clientPrice || 0,
      statusKey: String(
        (isCompany ? work.companyStatus : work.status) ?? ""
      ).toLowerCase(),
      statusLabel: translateStatus(
        isCompany ? work.companyStatus : work.status
      ),
      ...Object.fromEntries(
        ["measureDate", "orderDate", "finishDate"].map((key) => [
          key,
          formatDate(work[key]) || "--"
        ])
      ),
      dateValues: Object.fromEntries(
        ["measureDate", "orderDate", "finishDate"].map((key) => {
          const value = work[key] ? new Date(work[key]).getTime() : NaN;
          return [key, Number.isNaN(value) ? null : value];
        })
      )
    };
  });
  const config = {
    rowKey: "workId",
    emptyText: t("noWorks"),
    pageSize: 10,
    showPageSizeSelector: true,
    pageSizeOptions: [10, 25, 50, 100],
    showTotalCount: true,
    labels: { filter: t("filter"), search: t("search") },
    columns: [
      column("workId", "id", "7%"),
      ...(isAdmin ? [column("carpenterName", "user", "12%")] : []),
      column("partyName", isCompany ? "user" : "client", "12%"),
      ...(isCompany ? [column("clientName", "client", "12%")] : []),
      { ...column("name", "workName", "15%"), fixed: true },
      column("clientPrice", "totalPrice", "6%", "right"),
      {
        ...column("statusLabel", "status", "10%"),
        colorRule: {
          key: "statusKey",
          mode: "badge",
          values: statusColors,
          fallback: { color: "#495057", background: "#e9ecef" }
        }
      },
      dateColumn("measureDate", "measured"),
      dateColumn("orderDate", "ordered")
    ],
    onRowClick: (work) => onRowClick(work.workId)
  };
  return (
    <div className="dashboard-works-table">
      <CustomTable data={rows} config={config} />
    </div>
  );
}
